export default __webpack_public_path__ + "static/media/fundo-orcamento-p2.ced0a7e4.png";